import i18n from 'i18next';
import { useEffect, useState } from 'react';
import {
  getShippingTransportationGroup,
  getShippingTransportationShipmentGroup,
} from '../../../redux/common/CommonEffects';
import { transportationGroupData } from '../../screens/Quote/constants';
import FormSelectBox from '../Inputs/FormSelectBox';

const TransportationGroupSelector = ({
  placeholder = i18n.t('translation:default.fields.transportationGroup.placeholder'),
  label = i18n.t('translation:default.fields.transportationGroup.label'),
  rules = [],
  name,
  editMode,
  onChange,
  defaultValue,
  isAllRequired = false,
  isMockData = false,
  disableValidation,
  dataTestId,
  isGroupShipping,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isMockData) {
      getStatusList();
    }
  }, []);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } = isGroupShipping
        ? await getShippingTransportationShipmentGroup()
        : await getShippingTransportationGroup();
      let options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      if (isAllRequired) {
        options = [{ label: 'All', value: '' }, ...options];
      }
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  const labelValueData = transportationGroupData.map((item) => {
    return { label: item.value, value: item.id };
  });

  return (
    <FormSelectBox
      loading={loading}
      options={isMockData ? labelValueData : options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      defaultValue={defaultValue}
      name={name}
      editMode={editMode}
      onChange={onChange}
      disableValidation={disableValidation}
      dataTestId={dataTestId}
    />
  );
};

export default TransportationGroupSelector;
